import React, { useState } from 'react';
import MenuItem from './MenuItem';
import '../css/Sidebar.css';

function Sidebar({ isVisible, toggleSidebar }) {
  const [activeMenu, setActiveMenu] = useState(null);

  const handleMenuClick = (menu) => {
    setActiveMenu(activeMenu === menu ? null : menu);
  };

  return (
    <div className={`sidebar ${isVisible ? 'visible' : ''}`}>
      <button className="close-button" onClick={toggleSidebar}>×</button>
      <MenuItem
        title="홈 화면"
        isActive={activeMenu === '홈 화면'}
        onClick={() => handleMenuClick('홈 화면')}
        submenus={[
          { name: '홈 화면', path: '/' },
        ]}
        toggleSidebar={toggleSidebar}
      />
      <MenuItem
        title="일본 서버 데이터 마이그레이션"
        isActive={activeMenu === '일본 서버 데이터 마이그레이션'}
        onClick={() => handleMenuClick('일본 서버 데이터 마이그레이션')}
        submenus={[
          { name: '일본 CSV 다운로드', path: '/jp-server-csv-download' },
          { name: '일본 CSV 업로드', path: '/jp-server-csv-upload' },
        ]}
        toggleSidebar={toggleSidebar}
      />
      <MenuItem
        title="한국 상품 일괄등록"
        isActive={activeMenu === '한국 상품 일괄등록'}
        onClick={() => handleMenuClick('한국 상품 일괄등록')}
        submenus={[
          { name: '한국 상품데이터 엑셀 다운로드', path: '/bulk-product-export' },
          { name: '한국 상품 일괄등록', path: '/bulk-product-register' },
          { name: '한국 상품 순서 CSV 일괄등록', path: '/bulk-product-order-register' },
          { name: '한국 Database 업데이트', path: '/convert-xlsx-to-kr' }
        ]}
        toggleSidebar={toggleSidebar}
      />
      <MenuItem
        title="현지화 갱신작업"
        isActive={activeMenu === '현지화 갱신작업'}
        onClick={() => handleMenuClick('현지화 갱신작업')}
        submenus={[
          { name: '현지화/번역/이미지변환 작업', path: '/localize-database' },
          { name: '현지화 데이터베이스 작업', path: '/update-table-by-cache' },
        ]}
        toggleSidebar={toggleSidebar}
      />
      <MenuItem
        title="번역 엑셀 작업"
        isActive={activeMenu === '번역 엑셀 작업'}
        onClick={() => handleMenuClick('번역 엑셀 작업')}
        submenus={[
          { name: '번역 엑셀 추출', path: '/translation-xlsx-export' },
          { name: '번역 엑셀 업로드', path: '/translation-xlsx-update' },
          { name: '번역 엑셀 반영', path: '/translation-xlsx-apply' }
        ]}
        toggleSidebar={toggleSidebar}
      />
      <MenuItem
        title="데이터 검수작업"
        isActive={activeMenu === '데이터 검수작업'}
        onClick={() => handleMenuClick('데이터 검수작업')}
        submenus={[
          { name: '데이터 업데이트 적용', path: '/check-localization-update' },
          { name: '데이터 검수[개발해야함]', path: '/check-krdata-update' },
        ]}
        toggleSidebar={toggleSidebar}
      />
      <MenuItem
        title="JP샵 업로드용 CSV 작업"
        isActive={activeMenu === 'JP샵 업로드용 CSV 추출'}
        onClick={() => handleMenuClick('JP샵 업로드용 CSV 추출')}
        submenus={[
          { name: 'JP샵 업로드용 테이블 생성', path: '/update-jp-server-upload-table' },
          { name: 'JP샵 업로드용 테이블을 CSV로 추출', path: '/export-jp-server-upload-csv' }
        ]}
        toggleSidebar={toggleSidebar}
      />

      <MenuItem
        title="카테고리 등록"
        isActive={activeMenu === '카테고리 등록'}
        onClick={() => handleMenuClick('카테고리 등록')}
        submenus={[
          { name: '카테고리 등록', path: '/category-register' },
          { name: 'DB 컨버젼', path: '/category-db-conversion' },
          { name: 'CSV 추출', path: '/category-csv-export' }
        ]}
        toggleSidebar={toggleSidebar}
      />
      <MenuItem
        title="번역 xlsx 추출"
        isActive={activeMenu === '번역 xlsx 추출'}
        onClick={() => handleMenuClick('번역 xlsx 추출')}
        submenus={[
          { name: '번역 xlsx 추출', path: '/translation-xlsx-export' },
          { name: '번역 xlsx 업데이트', path: '/translation-xlsx-update' }
        ]}
        toggleSidebar={toggleSidebar}
      />
    </div>
  );
}

export default Sidebar;
